import styled, { css } from 'styled-components';

const colors = {
  white: '#fff',
  title: '#0f172a',
  text: '#334155',
  muted: '#64748b',

  border: '#ccc',
  borderSoft: '#cbd5e1',
  inputBorder: '#ccc',

  blue: '#3b82f6',
  green: '#047857',
  red: '#b91c1c',
};

const radius = {
  sm: '5px',
  md: '8px',
};

const spacing = {
  xs: '6px',
  sm: '8px',
  md: '12px',
  lg: '16px',
  xl: '20px',
  xxl: '24px',
};

const buttonBase = css`
  border: none;
  border-radius: ${radius.sm};
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const MasterWrapper = styled.div`
  display: grid;
  grid-template-columns: ${({ $showCatalogoPanel }) =>
    $showCatalogoPanel ? 'minmax(0, 1fr) minmax(0, 1fr)' : '1fr'};
  gap: ${spacing.xxl};
  align-items: start;
  height: calc(100% - 60px);
  min-height: 0;
`;

export const LeftWrapper = styled.div`
  min-height: 0;
  overflow: hidden;
`;

export const RightWrapper = styled.div`
  min-height: 0;
  max-height: 100%;
  overflow-y: auto;
  padding-right: ${spacing.sm};
`;

export const CatalogoCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.lg};
  border: 1px solid ${colors.border};
  border-radius: ${radius.sm};
  padding: 15px;
  margin-left: 5px;
`;

export const CatalogoHeader = styled.div`
  display: flex;
  justify-content: space-between;
  gap: ${spacing.md};
  flex-wrap: wrap;
`;

export const CatalogoHeaderInfo = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const CatalogoTitleRow = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
`;

export const CatalogoTitle = styled.h3`
  margin: 0;
  color: ${colors.title};
`;

export const CatalogoCount = styled.span`
  border-radius: ${radius.sm};
  background: ${colors.blue};
  color: ${colors.white};
  margin: 0 0 5px 15px;
  padding: 5px 10px;
`;

export const CatalogoDescription = styled.p`
  margin: 0;
  color: ${colors.text};
`;

export const CatalogoActionArea = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: ${spacing.md};
  margin-top: ${spacing.sm};
`;

export const PrimaryButton = styled.button`
  ${buttonBase};
  background: ${colors.blue};
  padding: 15px 20px;
  color: ${colors.white};
  cursor: pointer;
`;

export const CatalogoToolbar = styled.div`
  display: flex;
  gap: ${spacing.md};
  align-items: flex-end;
  flex-wrap: wrap;
`;

export const ToolbarButton = styled.button`
  ${buttonBase};
  background: ${colors.white};
  padding: 10px 16px;
  border: 1px solid ${colors.borderSoft};
  height: 38px;
  cursor: pointer;
`;

export const FilterContainer = styled.div`
  flex: 1;
  min-width: 260px;
  margin-left: 20px;
`;

export const FilterLabel = styled.span`
  display: block;
  margin-bottom: ${spacing.xs};
  font-weight: 600;
  color: ${colors.title};
`;

export const FilterInput = styled.input`
  width: 100%;
  height: 38px;
  border: 1px solid ${colors.inputBorder};
  border-radius: ${radius.sm};
  padding: 0 12px;
`;

